const availableColorTints = [
  '50',
  '100',
  '200',
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900'
];

export const colors = {
  bmPrimary: {
    50: '#E9F3FC',
    100: '#A6D0F2',
    200: '#7AB8EB',
    300: '#4DA0E5',
    400: '#2088DF',
    500: '#1C77C3',
    600: '#1867A9',
    700: '#15578E',
    800: '#124A78',
    900: '#0D3659'
  },
  bmPrimaryAlpha: {
    50: 'rgba(17,136,238, .05)',
    100: 'rgba(17,136,238, .1)',
    200: 'rgba(17,136,238, .2)',
    300: 'rgba(17,136,238, .3)',
    400: 'rgba(17,136,238, .4)',
    500: 'rgba(17,136,238, .5)',
    600: 'rgba(17,136,238, .6)',
    700: 'rgba(17,136,238, .7)',
    800: 'rgba(17,136,238, .8)',
    900: 'rgba(17,136,238, .9)'
  },
  bmInfo: {
    50: '#F0EEF6',
    100: '#DAD7EA',
    200: '#B5AED5',
    300: '#A097C9',
    400: '#8B7FBD',
    500: '#7668B1',
    600: '#6653A2',
    700: '#57478A',
    800: '#483B72',
    900: '#392F5A'
  }
};

const tokenToColorMap = {
  primary: 'bmPrimary',
  info: 'bmInfo',
  accent: 'bmPrimary',
  success: 'green',
  warning: 'orange',
  error: 'red',
  neutral: 'gray'
};

export const colorTokens = Object.entries(tokenToColorMap).reduce(
  (acc, [token, color]) => {
    availableColorTints.forEach((tint, index) => {
      acc[`${token}.${tint}`] = {
        default: `${color}.${
          availableColorTints[availableColorTints.length - 1 - index]
        }`,
        _dark: `${color}.${tint}`
      };
    });
    return acc;
  },
  {} as Record<string, {default: string; _dark: string}>
);
